/**
 * Accordion, jQuery Plugin
 *
 * This plugin provides an accordion with cookie support.
 *
 * Copyright (c) 2011 John Snyder (snyderplace.com)
 * @license http://www.snyderplace.com/accordion/license.txt New BSD
 * @version 1.1
 */
(function(jQuery) {
    jQuery.fn.accordion = function(options) {

        //firewalling
        if (!this || this.length < 1) {
            return this;
        }

        initialize(this, options);

    };

    //create the initial accordion
    function initialize(obj, options) {

        //build main options before element iteration
        var opts = jQuery.extend({}, jQuery.fn.accordion.defaults, options);

        //store any opened default values to set cookie later
        var opened = '';

        //iterate each matched object, bind, and open/close
        obj.each(function() {
            var jQuerythis = jQuery(this);
            saveOpts(jQuerythis, opts);

            //bind it to the event
            if (opts.bind == 'mouseenter') {
                jQuerythis.bind('mouseenter', function(e) {
                    e.preventDefault();
                    toggle(jQuerythis, opts);
                });
            }

            //bind it to the event
            if (opts.bind == 'mouseover') {
                jQuerythis.bind('mouseover',function(e) {
                    e.preventDefault();
                    toggle(jQuerythis, opts);
                });
            }

            //bind it to the event
            if (opts.bind == 'click') {
                jQuerythis.bind('click', function(e) {
                    e.preventDefault();
                    toggle(jQuerythis, opts);
                });
            }

            //bind it to the event
            if (opts.bind == 'dblclick') {
                jQuerythis.bind('dblclick', function(e) {
                    e.preventDefault();
                    toggle(jQuerythis, opts);
                });
            }

            //initialize the panels
            //get the id for this element
            id = jQuerythis.attr('id');

            //if not using cookies, open defaults
            if (!useCookies(opts)) {
                //close it if not defaulted to open
                if (id != opts.defaultOpen) {
                    jQuerythis.addClass(opts.cssClose);
                    opts.loadClose(jQuerythis, opts);
                } else { //its a default open, open it
                    jQuerythis.addClass(opts.cssOpen);
                    opts.loadOpen(jQuerythis, opts);
                    opened = id;
                }
            } else { //can use cookies, use them now
                //has a cookie been set, this overrides default open
                if (issetCookie(opts)) {
                    if (inCookie(id, opts) === false) {
                        jQuerythis.addClass(opts.cssClose);
                        opts.loadClose(jQuerythis, opts);
                    } else {
                        jQuerythis.addClass(opts.cssOpen);
                        opts.loadOpen(jQuerythis, opts);
                        opened = id;
                    }
                } else { //a cookie hasn't been set open defaults
                    if (id != opts.defaultOpen) {
                        jQuerythis.addClass(opts.cssClose);
                        opts.loadClose(jQuerythis, opts);
                    } else { //its a default open, open it
                        jQuerythis.addClass(opts.cssOpen);
                        opts.loadOpen(jQuerythis, opts);
                        opened = id;
                    }
                }
            }
        });

        //now that the loop is done, set the cookie
        if (opened.length > 0 && useCookies(opts)) {
            setCookie(opened, opts);
        } else { //there are none open, set cookie
            setCookie('', opts);
        }

        return obj;
    };

    //load opts from object
    function loadOpts(jQuerythis) {
        return jQuerythis.data('accordion-opts');
    }

    //save opts into object
    function saveOpts(jQuerythis, opts) {
        return jQuerythis.data('accordion-opts', opts);
    }

    //hides a accordion panel
    function close(opts) {
        opened = jQuery(document).find('.' + opts.cssOpen);
        jQuery.each(opened, function() {
            //give the proper class to the linked element
            jQuery(this).addClass(opts.cssClose).removeClass(opts.cssOpen);
            opts.animateClose(jQuery(this), opts);
        });
    }

    //opens a accordion panel
    function open(jQuerythis, opts) {
        close(opts);
        //give the proper class to the linked element
        jQuerythis.removeClass(opts.cssClose).addClass(opts.cssOpen);

        //open the element
        opts.animateOpen(jQuerythis, opts);

        //do cookies if plugin available
        if (useCookies(opts)) {
            // split the cookieOpen string by ","
            id = jQuerythis.attr('id');
            setCookie(id, opts);
        }
    }

    //toggle a accordion on an event
    function toggle(jQuerythis, opts) {
        // close the only open item
        if (jQuerythis.hasClass(opts.cssOpen))
        {
            close(opts);
            //do cookies if plugin available
            if (useCookies(opts)) {
                // split the cookieOpen string by ","
                setCookie('', opts);
            }
            return false;
        }
        close(opts);
        //open a closed element
        open(jQuerythis, opts);
        return false;
    }

    //use cookies?
    function useCookies(opts) {
        //return false if cookie plugin not present or if a cookie name is not provided
        if (!jQuery.cookie || opts.cookieName == '') {
            return false;
        }

        //we can use cookies
        return true;
    }

    //set a cookie
    function setCookie(value, opts)
    {
        //can use the cookie plugin
        if (!useCookies(opts)) { //no, quit here
            return false;
        }

        //cookie plugin is available, lets set the cookie
        jQuery.cookie(opts.cookieName, value, opts.cookieOptions);
    }

    //check if a accordion is in the cookie
    function inCookie(value, opts)
    {
        //can use the cookie plugin
        if (!useCookies(opts)) {
            return false;
        }

        //if its not there we don't need to remove from it
        if (!issetCookie(opts)) { //quit here, don't have a cookie
            return false;
        }

        //unescape it
        cookie = unescape(jQuery.cookie(opts.cookieName));

        //is this value in the cookie arrray
        if (cookie != value) { //no, quit here
            return false;
        }

        return true;
    }

    //check if a cookie is set
    function issetCookie(opts)
    {
        //can we use the cookie plugin
        if (!useCookies(opts)) { //no, quit here
            return false;
        }

        //is the cookie set
        if (jQuery.cookie(opts.cookieName) == null) { //no, quit here
            return false;
        }

        return true;
    }

    // settings
    jQuery.fn.accordion.defaults = {
        cssClose: 'accordion-close', //class you want to assign to a closed accordion header
        cssOpen: 'accordion-open', //class you want to assign an opened accordion header
        cookieName: 'accordion', //name of the cookie you want to set for this accordion
        cookieOptions: { //cookie options, see cookie plugin for details
            path: '/',
            expires: 7,
            domain: '',
            secure: ''
        },
        defaultOpen: '', //id that you want opened by default
        speed: 'slow', //speed of the slide effect
        bind: 'click', //event to bind to, supports click, dblclick, mouseover and mouseenter
        animateOpen: function (elem, opts) { //replace the standard slideDown with custom function
            elem.next().stop(true, true).slideDown(opts.speed);
        },
        animateClose: function (elem, opts) { //replace the standard slideUp with custom function
            elem.next().stop(true, true).slideUp(opts.speed);
        },
        loadOpen: function (elem, opts) { //replace the default open state with custom function
            elem.next().show();
        },
        loadClose: function (elem, opts) { //replace the default close state with custom function
            elem.next().hide();
        }
    };
})(jQuery);